<template>
	<div class="card-wrap">
		<h1 class="card--title text-center mb-1">
			{{ $t('easy-to-start.card1.title') }}
		</h1>
		<h1
			class="card--text text-center mb-5 mb-sm-8"
			v-html="$t('easy-to-start.card1.sub-title')"
		></h1>
		<v-img
			class="mx-auto"
			:width="userDevice === 'desktop' ? 261 : 235"
			:height="
				language === 'ko'
					? userDevice === 'desktop'
						? 337
						: 274
					: userDevice === 'desktop'
					? 303
					: 274
			"
			position="top center"
			:src="require(`@/assets/images/easily-book-${language}.png`)"
		></v-img>
	</div>
</template>

<script>
export default {
	computed: {
		userDevice() {
			return this.$store.getters['userDevice']
		},
		language() {
			return this.$store.getters['language']
		},
	},
}
</script>

<style lang="scss" scoped>
.card-wrap {
	padding: 40px 36px 0;
	border-radius: 20px;
	box-shadow: 0 11px 33px 0 rgba(33, 51, 82, 0.1);
	background-color: #fff;
}
.card--title {
	font-family: NotoSansKR;
	font-size: 22px;
	font-weight: bold;
	color: #1a1a1a;
}
.card--text {
	font-size: 16px;
	letter-spacing: -0.8px;
	color: #1a1a1a;
	font-weight: normal;
}
</style>
